!function ($) {
    "use strict";
    jQuery((function () {
            function getParameterByName(name, url = window.location.href) {
                name = name.replace(/[\[\]]/g, '\\$&');
                var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, ' '));
            }

            function updateBundleImage($this) {
                const swatch = $this.parents('.bundle_form').find('.swatch-option.current').first();

                const style = $(swatch).data('style');
                const country = $(swatch).data('country');
                if (window.bundle_gallery) {
                    const img = window.bundle_gallery.filter((o) => o[0].attribute_pa_styles === style && o[0].attribute_pa_countries === country)[0] ?? false;

                    if (img) {
                        const currentImg = $this.parents('.overlay-quickview').find('.woocommerce-product-gallery__wrapper img.wp-post-image').first()

                        $(currentImg).removeAttr('srcset')
                        $(currentImg).attr('src', img[1][0].url)
                        $(currentImg).attr('alt', img[1][0].alt_text)

                    }

                }
            }

            $('.bundle_form .swatch-option').click(function () {

                let product = $(this).closest('.product.product-type-bundle')
                updateFinePrint(product)



            })

            function updateFinePrint(product) {



                let fine_print_link = $(product).data('fine-print-link');
                let fine_print_text = $(product).data('fine-print-text');

                if (!fine_print_link || !fine_print_link.length) {
                    $(product).find('.bundled_item_cart_content').each(function (ix, item) {

                        fine_print_link = $(item).data('fine-print-link');
                        if (fine_print_link && fine_print_link.length) {
                            fine_print_text = $(item).data('fine-print-text');

                            return false;
                        }
                    })
                }
                setTimeout(function () {


                    if (!fine_print_link || !fine_print_link.length) {
                        $(product).find('.swatch-option.current').each(function (ix, item) {
                            fine_print_link = $(item).data('fine-print-link');
                            if (fine_print_link && fine_print_link.length) {
                                fine_print_text = $(item).data('fine-print-text');
                                return false;
                            }
                        })
                    }


                    $(product).find('.summary>.price').find('.fine-print-btns').remove();
                    $(product).find('#mobile_summary>.price').find('.fine-print-btns').remove();
                    if (fine_print_link) {


                    $(product).find('.summary>.price,#mobile_summary>.price').append($('<div class="fine-print-btns"></div>'));
                        var currentSwatch = $(product).find('.swatch-option.current');
                        let isLastChance = ( $(currentSwatch).data('last-chance') == undefined || ! $(currentSwatch).data('last-chance') ) ? "" : 'last-chance';
                        if( isLastChance != '' ){
                            $("#mobile_summary .fine-print").addClass(isLastChance);
                        }
                        let pbtn = '<button type="button" class="fine-print ' + isLastChance + '">' + fine_print_link + '</button>';
                        $(product).find('.fine-print-btns').append(pbtn);

                        let polContent = '<div class="fine-print__content" role="alertdialog" aria-label="' + fine_print_link + '" aria-modal="true">' + fine_print_text + '</div>';
                        $(product).find('.summary>.price,#mobile_summary>.price').find('.fine-print-btns button').on('click', function (e) {
                            e.preventDefault();
                            addOverlay(polContent, 'fine-print');
                        })
                    }

                }, 150)

            }


            function updateBundlePrice($this) {


                setTimeout(function(){
                    let product = $this.closest('.product')
                    const price_html = $('.bundle_price .price').html();
                    $(product).find('.summary>.price').html(price_html);
                    $(product).find('#mobile_summary>.price').html(price_html);
                    updateFinePrint(product)
                }, 100)

              

            }


            $('body').on('woocommerce-product-bundle-updated-totals', '.bundle_form .bundle_data', function () {


                updateBundlePrice(this)
            })

            $('body').on('woocommerce-product-bundle-updated', '.bundle_form .bundle_data', function (e, bundle) {

                if ($(this).parents('.overlay-quickview').length) {
                    updateBundleImage($(this))

                }

                setTimeout(function () {
                    if ($('.bundle_form').find('.out-of-stock').length > 1 || $('.bundle_error').attr('style').length === 0) {
                        $('.bundle_add_to_cart_button').text(window.ub_i18n.out_of_stock)
                        $('.bundle-errors').removeClass('empty')
                        $('.bundle-out-of-stock').html('')
                        const msg = $('.bundle-out-of-stock').data('oos-msg')
                        const style = $('.swatch-option.current').data('label')
                        $('.bundle_add_to_cart_button').attr('aria-disabled', true);
                        $('.bundle_form .bundled_product_summary:has(.out-of-stock)').each((ix, item) => {

                            const title = $(item).find('.item_title').text();
                            if ($(item).find('table.variations').length) {
                                $('.bundle-out-of-stock').append("<p class='item-out-of-stock'> " + title + " (" + style + ") " + msg + "</p>")
                            } else {
                                $('.bundle-out-of-stock').append("<p class='item-out-of-stock'> " + title + msg + "</p>")
                            }
                        })

                        $('.bundle-remaining-items').html('');
                        $('.bundle_form .bundled_product_summary:not(:has(.out-of-stock))').each((ix, item) => {
                            const title = $(item).find('.item_title').text();
                            const link = $(item).find('.bundled_product_permalink').attr('href')
                            $('.bundle-remaining-items').append('<div class="link-item"> <a href="' + link + '" target="_blank">' + title + "</a></div>")
                        })

                        //Hide this message if no products are available in bundle
                        if($('.bundle-remaining-items').is(":empty")){
                            $('.remaining-items-message').hide()

                        }


                    } else {
                        $('.bundle_add_to_cart_button').removeAttr('aria-disabled')
                        $('.item-out-of-stock').remove();
                        $('.bundle-errors').addClass('empty')

                        if (window.location.search.indexOf('update-bundle') !== -1) {
                            const cart_key = getParameterByName('update-bundle');
                            $('.bundle_add_to_cart_button').text(window.ub_i18n.update_cart).attr('data-update-product', cart_key);

                        } else {

                            $('.bundle_add_to_cart_button').text(window.ub_i18n.add_to_cart)

                        }
                    }


                }, 300)
            });


        }
    ))
}(jQuery);
